import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import FilterProject from "../../components/dashboard/FilterProject";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector,useDispatch } from "react-redux";
import {dateConvertToTimeStamp} from "../../services/Util";
import Constants from "../../Constants";
import { Link ,useSearchParams} from "react-router-dom";
import $ from "jquery";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { updateCampaignTag } from "../../redux/reducers/CampaignTagFilterSlice";
import Select from "react-select";
import { updateProjectRequestList } from "../../redux/reducers/ProjectRequestListSlice";
import DateFormat from "../DateFormat";
import useDebounce from "../../hooks/useDebounce";

const ProjectRequestList = (prop) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const [params ,setParams] = useSearchParams();

  const [pending, setPending] = useState(true);
  const [projectRequestListData, setProjectRequestListData] = useState([]);
  const [selectedFilterStatus, setFilterStatus] = useState(["&status=OPEN","&status=ACCEPTED"]);
  const [selectedAssignedTo, setSelectedAssignedTo] = useState({label: "Me" , value: false});
  const [currentPage, updateCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [sort, setSort] = useState("");
  const [perPage, setPerPage] = useState('20');
  const scrollRef = useRef(null);
  const paginationRef = useRef();
  const [sortFocus, setsortFocus] = useState('');
  const [searchText, setSearchText] = useState("");

  const department = useSelector((departmentSelected) => departmentSelected.select_dropdown).value;
  let tags = useSelector((updateCampaignTag) => updateCampaignTag.campaign_tag_filter).value;
  
  const tag = params.get('tag');



  $(document).ready(function(){
    $(".sc-gikAfH").html('<div style="min-width:1px !important;padding-left:0px !important" class="sc-ftTHYK sc-pyfCe sc-hBxehG jnJzqn vEyPn doDmkM rdt_TableCol" draggable="true"><div data-column-id="projectRequest.action"  role="columnheader" tabindex="-1" class="sc-fnGiBr bcCXtx rdt_TableCol_Sortable"><div data-column-id="projectRequest.action" class="sc-fEXmlR QHBTy"></div></div></div>')
    $(".sc-gikAfH").attr('data-column-id',"projectRequest.action")
    $('.rdt_Table button').parent().attr("role","cell")
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $('.rdt_Table').attr('aria-label', 'Project requests');
   })

  useEffect(() => {
    if(tag !==null){
        tags = [{label:tag,value:tag}];
        dispatch(updateCampaignTag(tags));
    }
    else if(tags?.length !== 0){ //if it is already a blank array then no need to set again as it will trigger unnecessarily other use effect
        tags = [];
        dispatch(updateCampaignTag(tags));
    }
  },[tag]);

   
  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
      <div role="row" className="no-data-display align-center">
        <div role="cell">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_DATA_FOUND}</p>
        </div>
      </div>
    </div>
    );
  }

  useEffect(() => {
    $('.lastdisable').trigger('focus');
    dispatch(updateProjectRequestList())
  }, [])


  const navigateBack = () => {
    navigate("/projects");
  };
  const ExpandedComponent = ({ data }) => (
    <div className="datatable-block groupTable">
      <div className="mar-bot16">
        <strong>Requester </strong>
        <p>{data?.owner?.firstName + " " + data?.owner?.lastName}</p>
      </div>
      <p>
        <strong>Target Languages</strong>
      </p>
      <table className="wrap-dropdown align-left w-330" style={{ width: "50%" }}>
        <thead>
          <tr>
            <th>Language</th>
            <th>Assignee</th>
            <th>Project</th>
          </tr>
        </thead>
        <tbody>
          {data?.requestTargetLanguages && data?.requestTargetLanguages?.length > 0 && data?.requestTargetLanguages?.map((targetLangs, index) => {
            return (
              <tr style={{ textAlign: "center" }} key={index}>
                <td className="align-left">{targetLangs?.language}</td>
                <td className="align-left">
                  {targetLangs?.assigneeUser !== ""
                    ? targetLangs?.assigneeUser?.fullName
                    : "Unassigned"}
                </td>
                <td className="align-left">
                  {data?.projectInfo?.projects &&  data?.projectInfo?.projects?.length > 0 ?
                  data?.projectInfo?.projects?.map((project, index) => {
                       if( targetLangs?.language===project?.targetLanguages[0] ){
                        return (
                          <Link to={`/project/${project?.id}`} key={index}>
                            {project?.name}
                          </Link>
                        )
                       }else{
                        return '';
                       }
                    ;
                  }) : 'No Project'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const projectRequestName=(e,row)=>{
     if(e.type === 'click' || e.key === Constants.ENTER){
      e.preventDefault()
      dispatch(updateProjectRequestList(row))
      navigate(`/project-request/show/${row.id}`)
     }

  }

  const columns = [
    {
      id: "projectRequest.name",
      name:translate("project_request.name"),
      selector: (row) => row?.name,
      sortable: true,
      reorder: true,
      cell: (row) =><Link to="#" className="linkColor" onClick={(e)=>projectRequestName(e,row)} onKeyDown={(e)=>projectRequestName(e,row)}>{row?.name}</Link> ,
    },
    {
      id: "projectRequest.department",
      name: translate("project_request.department"),
      selector: (row) => row?.userGroup,
      sortable: true,
      reorder: true,
      cell: (row) => row?.userGroup?.name,
    },
    {
      id: "projectRequest.projectInfo",
      name: translate("project_request.projects"),
      reorder: true,
      selector: (row) => row?.projectStatusCount?.inReview,
      cell: (row) =>
      row?.projectInfo?.projects?.length !== 0 ?
        row?.projectInfo?.projects?.map((project, index) => {
          return (
            <Link to={`/project/${project?.id}`} key={index}>
            <span>{project?.name}{ (row?.projectInfo?.projects?.length -1) > index ? " , ":""}&nbsp;</span>
            </Link>
          );
        }) : translate("project_request.no_open_completed_project_exits"),
    }, 
    {
      id: "projectRequest.createdDate",
      name: translate("project_request.requested_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div>
          <DateFormat date={row.createdDate} />
        </div>
      ),
    },
    {
      id: "projectRequest.status",
      name:  translate("project_request.status"),
      left: true,
      reorder: true,
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => allStatus(row.status),
    },
  ];
  
  const allStatus=(activeStatus)=>{
    let  status=""
      if(activeStatus==="CLOSED") {
        status="Completed"
      }else if(activeStatus === "REJECTED"){
        status="Canceled"
      }else if(activeStatus==="OPEN"){
        status="Open"
      }else if(activeStatus==="ACCEPTED"){
        status="Accepted"
      }
    return status;
  }  
  

  const handlePageChange = (paging) => {
    updateCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  const handleSort = async (column, sortDirection) => {
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort":
        order === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING,
    });
    setSort(sortedString);
  };


  const onRequestStatusChange = (val) => {
    if(val && val.length > 0) {
      setFilterStatus(val.map(val => val.value));
    } else {
      setFilterStatus([])
    }
  }

  const getData = (newPerPage, page) =>{
    let status = '';
    let selectedTags = '';
    let selectedDepartment = '';
    let assignee = `&allUsers=false`;
    let name = ""
    if(searchText) {
      name = `&name=${searchText}`;
    }
    selectedFilterStatus?.map(selectedStatus => status += selectedStatus);
    tags?.map(tag => selectedTags += `&tag=${tag.value}`);
    if(selectedAssignedTo.length > 0 || Object.keys(selectedAssignedTo).length > 0) {
      assignee = `&allUsers=${selectedAssignedTo.value}`
    }
    const dateTimestamp = dateConvertToTimeStamp();
    selectedDepartment = selectedFilterStatus !== '' ? `userGroup=${department}` : '';
    getAxiosResponse(APIUrls.GET_PROJECT_REQUEST_LIST+
      `?${selectedDepartment}${status}${selectedTags}${assignee}${name}&page=${page}&pageSize=${newPerPage}${sort}&_=${dateTimestamp}`
    ).then((res) => {
      if (res?.data !== "") {
        let finalData=res?.data?.data?.resource?.result
        let resultcount=res?.data?.data?.resource?.resultCount;
        if(finalData !=="" && finalData !==undefined && finalData !==null){
          setProjectRequestListData(finalData);
          setTotalRows(resultcount);
          setPending(false);
        }

      setTimeout(() => {
        if(sortFocus){
          $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
          setsortFocus('');
        }
        if (paginationRef.current) {
              $('#'+ paginationRef.current).trigger('focus');
              paginationRef.current = '';
          }
        }, 300);
      }
    });   
  }
  
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    getData(newPerPage, page);
    setTimeout(function(){
      $('.datatable-block.hide-per-page').find('nav.rdt_Pagination select').trigger('focus');
    }, 100);
  };

    //use debounce mechanism to avoid multiple api calls with 1 second
  const [changeNo, setChangeNo] = useState(0);
  const debouncedChangeNo = useDebounce(changeNo, 1000);

  useEffect(() => {
      setChangeNo(changeNo + 1);
  }, [selectedFilterStatus,tags,department,selectedAssignedTo,currentPage,sort, searchText]);

  useEffect(() => {
    getData(perPage, currentPage);
  }, [debouncedChangeNo]);

  const filterFunction = () => {
    var element = document.getElementById("filterBtn");
    var element2 = document.getElementById("activeId");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");
    $('#activeId').attr('aria-expanded', function(_, attr) {
      return attr === 'false' ? 'true' : 'false';
    });
  };
  const crumbs = [
    {label:'Project requests', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={ crumbs } />
            <div className="dashboard-top flex-center">
              <div className="flex-left flex-center">
                <div className="fliter">
                  <button
                    id="activeId"
                    className="dashboard-btn active"
                    onClick={filterFunction}
                    aria-expanded="false"
                  >
                    <span className="filter-icon">
                      <svg
                        width="19"
                        height="14"
                        viewBox="0 0 19 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                          fill="#1D4ED8"
                        />
                        <path
                          d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </span>{" "}
                    {translate("filters")}
                  </button>
                </div>
              </div>
              <div className="flex-right"></div>
            </div>
            <div>&nbsp;</div>
            <FilterProject filter={prop.filterType} onRequestStatusChange={onRequestStatusChange} onChangeAssignedTo={setSelectedAssignedTo} setSearchText={setSearchText} />
            <div className="white-bg">
              <div className="name-card-section">
                <div className="name-card-section-left">
                  <div className="campaign-name">
                    <button
                      onClick={navigateBack}
                      className="back-btn"
                      aria-label="back"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                      >
                        <path
                          d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#4D4D4D"
                        />
                      </svg>
                    </button>
                    <h3>{translate("project_request.project_requests")}</h3>
                  </div>
                </div>
                <div className="name-card-section-right">
                  <div className="progress-btn" id="progress-btn">
                    <div className="inner-popover"></div>
                  </div>
                </div>
              </div>
              <div className="listing-content">
                <div className="campaign_details-task project-request project-request-list">

                  <div className="task-content">
                    <div className="datatable-block hide-per-page">
                      <DataTable
                        className="campaign-datatable-block"
                        keyField="id"
                        columns={columns}
                        data={projectRequestListData}
                        expandableRows
                        expandableRowExpanded={(row) => row.defaultExpanded}
                        expandableRowsComponent={ExpandedComponent}
                        pagination
                        pageLength = {20}
                        onSort={handleSort}
                        progressPending={pending}
                        onChangeRowsPerPage={handlePerRowsChange}
                        paginationPerPage={20}
                        paginationTotalRows={totalRows}
                        paginationRowsPerPageOptions={[20, 30,40, 50, 100, 200]}
                        onChangePage={handlePageChange}
                        noDataComponent={noDataFoundComponent()}
                    responsive
                    pointerOnHover={true}
                    paginationServer
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProjectRequestList;
